import { initializeApp } from "firebase/app";
// import 'firebase/auth'
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAnbljEh99CwMat2WQipLHd35Ykb40NxXo",
  authDomain: "crypto-trading-platform-e379d.firebaseapp.com",
  databaseURL:
    "https://crypto-trading-platform-e379d-default-rtdb.firebaseio.com",
  projectId: "crypto-trading-platform-e379d",
  storageBucket: "crypto-trading-platform-e379d.appspot.com",
  messagingSenderId: "410083052106",
  appId: "1:410083052106:web:747b1043a4cbbe5fc4f4b3",
  measurementId: "G-LFKZRVC8YJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log("Analytics: ", analytics);

// let auth = app.auth();
// let provider = new app.auth.GoogleAuthProvider();
// export {auth , provider};
